import { makeStyles } from 'tss-react/mui';

export default makeStyles()((theme) => ({
  /** Page `<main>` in `index.tsx`: gap between hero section and feed. */
  main: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    [theme.breakpoints.up('md')]: {
      gap: theme.spacing(6),
    },
  },
  /** Top space under the app bar when the full-bleed hero is not rendered. */
  mainWithoutHero: {
    marginTop: theme.spacing(3),
    [theme.breakpoints.up('md')]: {
      marginTop: theme.spacing(6),
    },
  },
  container: {
    width: '100%',
    maxWidth: '100%',
    minWidth: 0,
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    alignSelf: 'stretch',
    gap: theme.spacing(3),
  },
  /** Width only; centering is via `Stack` in the Home layout. */
  adSpace: {
    width: '100%',
  },
  /** Section header + `PostGrid` spacing (matches `SectionHeader` + content `gap`). */
  latestPostsSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    width: '100%',
  },
}));
